// Recoil
import { useSetRecoilState, useResetRecoilState } from "recoil";
import { menuState, isMenuView } from "../../atom/pos";

function PosSideMenu() {
  // Recoil State
  const setMenuType = useSetRecoilState(menuState);
  const resetMenuView = useResetRecoilState(isMenuView);

  // useState
  const menuList = [
    "브이디메뉴 관리",
    "매출조회",
    "파트너어드민",
    "브이디웨이팅",
    "환경설정",
    "설정 업데이트",
    "로그아웃",
  ];

  // Function
  const movePage = (type: string) => {
    if (type === "매출조회") {
      setMenuType(1);
    }
    if (type === "브이디메뉴 관리") {
      setMenuType(2);
    }
    resetMenuView();
  };

  return (
    <>
      <div className='side-menu-wrap'>
        <div className='flex col' style={{ gap: 4 }}>
          {menuList.map((v) =>
            v === "매출조회" || v === "브이디메뉴 관리" ? (
              <div
                className='menu-list pointer'
                onClick={() => {
                  movePage(v);
                }}
              >
                {v}
              </div>
            ) : (
              <div
                className='menu-list'
                onClick={() => {
                  movePage(v);
                }}
              >
                {v}
              </div>
            )
          )}
        </div>
        <div className='side-menu-bottom'>
          <span>판매자 : 홍길동</span>
          <p>version : 20231111</p>
        </div>
      </div>
    </>
  );
}

export default PosSideMenu;
